import { render, staticRenderFns } from "./ContractPaymentMethodsDetails.vue?vue&type=template&id=235f5e72&scoped=true&"
import script from "./ContractPaymentMethodsDetails.vue?vue&type=script&lang=js&"
export * from "./ContractPaymentMethodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContractPaymentMethodsDetails.vue?vue&type=style&index=0&id=235f5e72&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f5e72",
  null
  
)

export default component.exports